var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primary-navigation",
    transform: "translate(-351.000000, -166.000000)",
    stroke: "#E5E5EA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Example-state-2",
    transform: "translate(64.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Breadcrumbs",
    transform: "translate(28.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Caret",
    transform: "translate(250.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10 16 14 12 10 8"
  }))))))));
};
export { SvgIconArrowRight as ReactComponent };
export default __webpack_public_path__ + "icon-arrow-right.svg";